    import once from '../../../src/js/utils/once.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock/lib/bodyScrollLock.es6.js';

export default function () {
    window.Drupal.behaviors.mobileMenuScrollLock = {
        attach: (context) => {

            const overlay = document.querySelector('overlay-component[data-name="mobileMenu"]');

            once(overlay, 'mobilemenu', () => {
                overlay.addEventListener('open', (event) => {
                    disableBodyScroll(event.target);
                });

                overlay.addEventListener('close', (event) => {
                    enableBodyScroll(event.target);
                });
            });
        }
    }
}
